<template>
	<div id="app">
		<Header />

		<router-view />

		<Rooter />
	</div>
</template>

<script>
	import Header from './layout/header.vue'
	import Rooter from './layout/rooter.vue'

	export default {
		name: 'App',
		components: {
			Header,
			Rooter
		},
		mounted() {
			document.title = '职教数';
		}
	}
</script>

<style scoped>
	#app {
		background-image: url("./assets/background.png");
		background-repeat: no-repeat;
		background-color: #F4F5F6;
		background-size: 100% auto;
	}
</style>